import React from 'react';
import agileOffroadSrc from './Logos/agile-offroad.png';
import crunchLabsSrc from './Logos/crunch-labs.png';
import mainlyBrandsSrc from './Logos/manly-bands.png';
import myDermaDreamSrc from './Logos/my-derma-dream.png';
import nurecoverSrc from './Logos/nurecover.png';
import viiaHempSrc from './Logos/viia-hemp.png';
import styles from './Partners.module.css';

export const Brands = () => {
  return (
    <div className={styles.brandsContainer}>
      <img src={crunchLabsSrc} alt="CrunchLabs" />
      <img src={mainlyBrandsSrc} alt="Mainly Brands" />
      <img src={myDermaDreamSrc} alt="MyDermaDream" />
      <img src={viiaHempSrc} alt="Viia Hemp" />
      <img src={agileOffroadSrc} alt="Agile Offroad" />
      <img src={nurecoverSrc} alt="Nurecover" />
    </div>
  );
};
